import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RequestService } from 'src/app/api/request.service';
import { LoginService } from 'src/app/login/login.service';
import { LanguageService } from 'src/app/services/language.service';
import { customPasswordValidatorBuilder, ValidatorBuilder } from 'src/app/ui/validator';

const newPasswordValidator = new ValidatorBuilder<{ password: string }>().custom(
  'password',
  customPasswordValidatorBuilder({
    tooShort: (_, c: SetPasswordComponent) => c.trans('auth.errors.passwordTooShort'),
    noLowerCase: (_, c: SetPasswordComponent) => c.trans('auth.errors.passwordNoLowercase'),
    noUpperCase: (_, c: SetPasswordComponent) => c.trans('auth.errors.passwordNoUppercase'),
    noNumber: (_, c: SetPasswordComponent) => c.trans('auth.errors.passwordNoNumber'),
  })
);

@Component({
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
})
export class SetPasswordComponent implements OnInit {
  public isLoading = false;
  public val = newPasswordValidator.build().bindContext(this);
  public readonly trans = (key: string) => this.ls.get(key);
  constructor(public login: LoginService, private router: Router, private req: RequestService, private ls: LanguageService) {}

  ngOnInit(): void {
    if (!this.login.passwordToken) {
      this.router.navigate(['login']);
    }
  }

  public async next() {
    if (!(await this.val.validate(this.login))) { return; }
    this.isLoading = true;
    const res = await this.req.login.passwordCreate({ password: this.login.password, passHash: this.login.passwordToken, email: this.login.email }).toPromise();
    if (res.success === false) {
      this.val.pushError('password', res.error);
      this.isLoading = false;
      return;
    }
    this.login.passwordToken = undefined;
    const loginRes = await this.login.login(this.login.email, this.login.password).toPromise();
    if (loginRes.success === false) {
      this.val.pushError('password', loginRes.error);
      this.isLoading = false;
      return;
    }
    this.login.password = undefined;
    if (!loginRes.name) {
      this.router.navigate(['login', 'register', 'name'], { replaceUrl: true });
      return;
    }
    this.router.navigate(this.login.determineLoginDestination(), { replaceUrl: true });
  }
}
